import { knowledgeDepthOptions as conceptKnowledgeDepth, questionToneOptions as conceptQuestionTone } from "../data/concept-questions/questionBuilder";
import { simplificationLevelOptions } from "../data/content-simplifier/builder";
import { targetFormatOptions as difficultyBalancerFormats } from "../data/difficulty-balancer/builder";
import { understandingLevelOptions } from "../data/explain-differently/builder";
import { gradeOptionLabels } from "../data/quick-sheets/filterOptionLabels";
import { getFilterFields } from "../data/quick-sheets/filterRegistry";
import {
  difficultyOptions as quickSheetsDifficulty,
  questionTypes as quickSheetsQuestionTypes,
  worksheetFormatOptions,
} from "../data/quick-sheets/worksheetBuilder";
import { targetFormatOptions as quickAssessmentFormats } from "../data/quick-assessment/builder";
import { difficultyOptions as realWorldDifficulty } from "../data/real-world-task/builder";
import { targetFormatOptions as teachThisTopicFormats } from "../data/teach-this-topic/builder";
import { knowledgeDepthOptions as variationKnowledgeDepth } from "../data/question-variations/builder";
import { questionToneOptions as variationQuestionTone } from "../data/question-variations/builder";
import { questionTypeOptions } from "../data/question-paper/builder";
import {
  labelsToAllowedSet,
  optionLabelsToAllowedSet,
} from "./common";

export function getStandardCurriculumSets() {
  const filterFields = getFilterFields();
  const curriculumOptions =
    filterFields.find((field) => field.id === "curriculum")?.options ?? [];
  const subjectOptions =
    filterFields.find((field) => field.id === "subject")?.options ?? [];

  return {
    curriculum: labelsToAllowedSet(curriculumOptions.map((option) => option.label)),
    grade: labelsToAllowedSet(gradeOptionLabels),
    subject: labelsToAllowedSet(subjectOptions.map((option) => option.label)),
  };
}

export const DIFFICULTY_LABELS = optionLabelsToAllowedSet(quickSheetsDifficulty);
export const QUESTION_TYPE_LABELS = optionLabelsToAllowedSet(quickSheetsQuestionTypes);
export const WORKSHEET_FORMAT_LABELS = optionLabelsToAllowedSet(worksheetFormatOptions);
export const KNOWLEDGE_DEPTH_LABELS = optionLabelsToAllowedSet(conceptKnowledgeDepth);
export const CONCEPT_QUESTION_TONE_LABELS = optionLabelsToAllowedSet(conceptQuestionTone);
export const QUESTION_TONE_LABELS = optionLabelsToAllowedSet(variationQuestionTone);
export const TEACHING_TARGET_FORMAT_LABELS = labelsToAllowedSet([
  ...quickAssessmentFormats.map((option) => option.label),
  ...difficultyBalancerFormats.map((option) => option.label),
  ...teachThisTopicFormats.map((option) => option.label),
]);
export const UNDERSTANDING_LEVEL_LABELS = optionLabelsToAllowedSet(
  understandingLevelOptions,
);
export const SIMPLIFICATION_LEVEL_LABELS = optionLabelsToAllowedSet(
  simplificationLevelOptions,
);
export const REAL_WORLD_DIFFICULTY_LABELS = optionLabelsToAllowedSet(
  realWorldDifficulty,
);
export const QUESTION_PAPER_TYPE_LABELS = optionLabelsToAllowedSet(questionTypeOptions);

export const VARIATION_KNOWLEDGE_DEPTH_LABELS = optionLabelsToAllowedSet(
  variationKnowledgeDepth,
);
